import { MutationCache, QueryClient } from "@tanstack/react-query";
import { ApiError, isRequestTimeout, isUncertainWriteTimeout } from "./api/client";

const QUERY_RETRIES = 1;

export function createQueryClient(): QueryClient {
  const queryClient: QueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 2,
        gcTime: 1000 * 60 * 10,
        retry: (failureCount, error) => !isRequestTimeout(error) && failureCount < QUERY_RETRIES,
        refetchOnWindowFocus: false,
      },
    },
    mutationCache: new MutationCache({
      onError: (error) => {
        if (isUncertainWriteTimeout(error) || error instanceof TypeError) {
          queryClient.invalidateQueries({}, { cancelRefetch: false });
          return;
        }
        if (error instanceof ApiError && error.status === 403) {
          queryClient.invalidateQueries({ queryKey: ["apps"] });
          queryClient.invalidateQueries({ queryKey: ["deployments"] });
        }
      },
    }),
  });
  return queryClient;
}
